import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import useSaveTalent from '../../../../../../hooks/talents/useSaveTalent';
import useCreateConversation from '../../../../../../hooks/conversations/useCreateConversation';
import useCheckConversation from '../../../../../../hooks/conversations/useCheckConversation';
import {  starIcon, scheduleIcon, userChefIcon, timerIcon } from '../../../../../../utils/icons';
import './applicantCard.css'
import useSignedImage from '../../../../../../hooks/useSignedImage';

const ApplicantCard = ({ data, type, mode, jobPostId: jobPostIdProp }) => {
    const {
        employee = {},
        id,
        employeeId,
        jobPostId: dataJobPostId
    } = data ?? {};
    const jobPostId = jobPostIdProp ?? dataJobPostId;
    const {
        name = '',
        position = '',
        available = '',
        schedule = '',
        profileImageUrl = ''
    } = employee;

    const { saveTalent, isLoading: talentLoading, error: talentError } = useSaveTalent();
    const { createConversation, isLoading: conversationLoading, error: conversationError } = useCreateConversation();
    const {  conversationExists, isLoading, error, conversation,  checkConversationExistence } = useCheckConversation()
    const navigate = useNavigate()


    useEffect(() => {
        if (employeeId && jobPostId) {
            checkConversationExistence(employeeId, 'application', jobPostId);
        }
    }, [employeeId, jobPostId, checkConversationExistence]);
    

    const handleConversationInitiation = async () => {
        if (!conversationLoading && !conversationError) {
            const newConversation = await createConversation(employeeId, jobPostId, 'applicant');
            
            if (newConversation && newConversation.id) {
                navigate(`/panel-empresa/inbox-empresa/${newConversation.id}/${employeeId}`);
            } 
        } 
    };

    const { imageUrl: signedEmployeeImageUrl } = useSignedImage(profileImageUrl, '/default-employee.png');

    return (
        <div className="applicant-card__container">
            <div className="applicant-card__col-1">
                <img className="applicant-card__company-logo" src={signedEmployeeImageUrl} alt={name} />
                <div className="applicant-card__info">
                    <p>{name}</p>
                </div>
            </div>
            <div className="applicant-card__col-2-container"> 
                <div className="applicant-card__col-2">
                    <div className="applicant-card__info-container">
                        <div className="applicant-card__icon-container">
                        {userChefIcon}
                        </div>
                        <div>
                            <p><strong>Cargo:</strong></p>
                            <p>{position}</p>
                        </div>
                    </div>
                    <div className="applicant-card__info-container">
                        <div className="applicant-card__icon-container">
                        {starIcon}
                        </div>
                        <div>
                            <p><strong>Experiencia:</strong></p>
                            <p>3 años</p>
                        </div>
                    </div>
                </div>
                <div className="applicant-card__col-2">
                    <div className="applicant-card__info-container">
                        <div className="applicant-card__icon-container">
                        {scheduleIcon}
                        </div>
                        <div>
                            <p><strong>Disponibilidad:</strong></p>
                            <p>{available}</p>
                        </div>
                    </div>
                    <div className="applicant-card__info-container">
                        <div className="applicant-card__icon-container">
                        {timerIcon}
                        </div>
                        <div>
                            <p><strong>Jornada:</strong></p>
                            <p>{schedule}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className='applicant-col-3'>
                <div className="applicant-card__button-container">
                    <Link to={`/empleados/${employeeId}`}>
                        <button className="applicant-card__button">Perfil</button>
                    </Link>
                
                    {mode === 'Hired' ? (
                        <Link to={`/empleados/${employeeId}`}>
                            <button className="applicant-card__button">Ver</button>
                        </Link>
                    ) : (
                        <Link to={`/panel-empresa/trabajos/postulantes/${id}`}>
                            <button className="applicant-card__button">Ver</button>
                        </Link>
                    )}

                    {conversationExists && conversation ? (
                        <Link to={`/panel-empresa/inbox-empresa/${conversation.id}/${employeeId}`}>
                            <button className="applicant-card__button">Ver chat</button>
                        </Link>
                    ) : (
                        <button
                            onClick={handleConversationInitiation}
                            className="applicant-card__button"
                            disabled={conversationLoading}
                        >
                            {conversationLoading ? 'Iniciando...' : 'Chat'}
                        </button>
                    )}


                </div>
                {talentError && <p className="error-message">{talentError.message}</p>}
                {conversationError && <p className="error-message">{conversationError.message}</p>}
            </div>
        </div>
    );
};

export default ApplicantCard;
